export default __webpack_public_path__ + "static/media/settings.7a75e2b5.svg";